import type { BaseStepType, IntakeStatusBaseSteps } from '@shared/patient-intake-status';

/**
 * Check if the given step is the ID Verification step and if its status is either 'PENDING' or 'NOT_STARTED'.
 */
export const getIsPendingIdVerificationStep = <TBaseStepType extends BaseStepType>(
  step: IntakeStatusBaseSteps[TBaseStepType] | undefined,
): boolean => step?.id === 'ID_VERIFICATION' && ['PENDING', 'NOT_STARTED'].includes(step?.currentStatus?.status);
